import { AccommodationItemAddonType } from './types';

// todo what about other chartTypes
export function getAccommodationItemAddonMaxQuantity(
  chargeType: AccommodationItemAddonType['chargeType']
) {
  if (chargeType === 'PerBooking') return 1;

  return 10;
}
